
{
  "familyId": "GET-MACHT",
  "questions": [
    {
      "id": "GET-MACHT-001",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Een wetenschapper schrijft $2^3$ op. Wat betekent dit?",
      "options": ["2 × 2 × 2", "2 + 2 + 2", "2 × 3", "3 × 3"],
      "correctAnswer": 0,
      "conceptId": "power_notation_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Machtsverheffing", "content": "$a^n$ = a × a × a ... (n keer). Het grondtal (a) wordt n keer met zichzelf vermenigvuldigd. Voorbeeld: $2^3$ = 2 × 2 × 2 = 8.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De wetenschapper weet: $2^3$ betekent dat het grondtal 2 drie keer met zichzelf wordt vermenigvuldigd. De exponent (3) zegt hoe vaak. Dus $2^3$ = 2 × 2 × 2 = 8.",
        "solutionSteps": ["Grondtal = 2, exponent = 3", "De exponent zegt: vermenigvuldig het grondtal 3 keer", "$2^3$ = 2 × 2 × 2 = 8"],
        "distractorExplanations": {
          "0": "Goed! $2^3$ = 2 × 2 × 2 = 8. De exponent 3 zegt hoe vaak je het grondtal vermenigvuldigt.",
          "1": "Je dacht waarschijnlijk dat je het grondtal moet optellen. Maar 2 + 2 + 2 = 6 is optellen, niet machtsverheffing. Onthoud: machtsverheffing = vermenigvuldigen.",
          "2": "Je dacht waarschijnlijk dat je grondtal × exponent doet. Maar 2 × 3 = 6 is gewoon vermenigvuldigen. Bij $2^3$ vermenigvuldig je 2 met zichzelf (3 keer): 2 × 2 × 2 = 8. Onthoud: de exponent is geen factor.",
          "3": "Je dacht waarschijnlijk dat de exponent het grondtal is. Maar bij $2^3$ is 2 het grondtal, niet 3. Dus 2 × 2 × 2 = 8, niet 3 × 3 = 9. Onthoud: het onderste getal is het grondtal."
        }
      }
    },
    {
      "id": "GET-MACHT-002",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Een ingenieur berekent het oppervlak van een vierkant met zijde 3 cm. Welke berekening hoort erbij?",
      "options": ["$3^2$ = 9 cm²", "3 × 2 = 6 cm²", "3 + 3 = 6 cm²", "$2^3$ = 8 cm²"],
      "correctAnswer": 0,
      "conceptId": "power_square_context",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Kwadraat en oppervlakte", "content": "Het oppervlak van een vierkant = zijde × zijde = zijde². Dus: 3 × 3 = $3^2$ = 9 cm².", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De ingenieur weet: het oppervlak van een vierkant = zijde × zijde = zijde². Dus: 3 × 3 = $3^2$ = 9 cm². Daarom heet het ook 'kwadraat' — het hoort bij vierkanten.",
        "solutionSteps": ["Oppervlak vierkant = zijde × zijde", "= 3 × 3 = $3^2$", "= 9 cm²"],
        "distractorExplanations": {
          "0": "Goed! $3^2$ = 3 × 3 = 9 cm². Het oppervlak van een vierkant is zijde².",
          "1": "Je dacht waarschijnlijk dat je zijde × 2 doet. Maar 3 × 2 = 6 is de helft van de omtrek, niet het oppervlak. Onthoud: oppervlak = zijde × zijde, niet zijde × 2.",
          "2": "Je dacht waarschijnlijk dat je de zijden optelt. Maar 3 + 3 = 6 is een deel van de omtrek. Onthoud: oppervlak = vermenigvuldigen, niet optellen.",
          "3": "Je dacht waarschijnlijk dat je grondtal en exponent omdraait. Maar $2^3$ = 8, terwijl je $3^2$ = 9 nodig hebt. Onthoud: het grondtal is de zijde (3), de exponent is 2 (kwadraat)."
        }
      }
    },
    {
      "id": "GET-MACHT-003",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Een programmeur verdubbelt data elke dag. Na 4 dagen is het $2^4$ keer zo groot. Hoeveel is dat?",
      "options": ["16", "8", "6", "12"],
      "correctAnswer": 0,
      "conceptId": "power_context_doubling",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.73,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Verdubbeling als macht", "content": "Elke dag verdubbelt = ×2 per dag. Na 4 dagen: 2 × 2 × 2 × 2 = $2^4$ = 16.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De programmeur weet: elke dag verdubbelen = ×2 per dag. Na 4 dagen: 2 × 2 × 2 × 2 = $2^4$ = 16 keer zo groot. Stap voor stap: dag 1: ×2 = 2, dag 2: ×2 = 4, dag 3: ×2 = 8, dag 4: ×2 = 16.",
        "solutionSteps": ["$2^4$ = 2 × 2 × 2 × 2", "Stap 1: 2 × 2 = 4", "Stap 2: 4 × 2 = 8", "Stap 3: 8 × 2 = 16"],
        "distractorExplanations": {
          "0": "Goed! $2^4$ = 2 × 2 × 2 × 2 = 16.",
          "1": "Je dacht waarschijnlijk dat $2^4$ = $2^3$ = 8. Maar de exponent is 4, niet 3. Na 4 dagen: 2 × 2 × 2 × 2 = 16. Onthoud: tel het aantal keren vermenigvuldigen.",
          "2": "Je dacht waarschijnlijk dat je 2 + 4 = 6 doet. Maar machtsverheffing is vermenigvuldigen, niet optellen. Onthoud: $2^4$ = 2 × 2 × 2 × 2 = 16.",
          "3": "Je dacht waarschijnlijk dat je 2 × 4 + 4 = 12 doet. Maar $2^4$ = 2 × 2 × 2 × 2 = 16. Onthoud: de exponent zegt hoe vaak je vermenigvuldigt."
        }
      }
    },
    {
      "id": "GET-MACHT-004",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Een bioloog bestudeert bacteriën die zich elke uur verdrievoudigen. Na 3 uur zijn het er $3^3$. Hoeveel is dat?",
      "options": ["27", "9", "15", "12"],
      "correctAnswer": 0,
      "conceptId": "power_cube_context",
      "variantIndex": 4,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.78,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Derde macht berekenen", "content": "$3^3$ = 3 × 3 × 3 = 27. Stap 1: 3 × 3 = 9. Stap 2: 9 × 3 = 27.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De bioloog berekent: $3^3$ = 3 × 3 × 3 = 27 bacteriën. Stap 1: 3 × 3 = 9. Stap 2: 9 × 3 = 27. Elke uur ×3, dus na 3 uur: $3^3$ = 27.",
        "solutionSteps": ["$3^3$ = 3 × 3 × 3", "Stap 1: 3 × 3 = 9", "Stap 2: 9 × 3 = 27"],
        "distractorExplanations": {
          "0": "Goed! $3^3$ = 3 × 3 × 3 = 27.",
          "1": "Je dacht waarschijnlijk dat $3^3$ = $3^2$ = 9. Maar de exponent is 3, niet 2. Je moet nog een keer ×3: 9 × 3 = 27. Onthoud: de exponent zegt hoe vaak.",
          "2": "Je dacht waarschijnlijk dat je 3 × 5 = 15 doet. Maar $3^3$ = 3 × 3 × 3 = 27. Onthoud: machtsverheffing is herhaald vermenigvuldigen.",
          "3": "Je dacht waarschijnlijk dat je 3 × 4 = 12 doet. Maar $3^3$ = 3 × 3 × 3 = 27. Onthoud: de exponent zegt hoe vaak je het grondtal vermenigvuldigt."
        }
      }
    },
    {
      "id": "GET-MACHT-005",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Een astronoom schrijft grote getallen als machten van 10. Hoeveel is $10^4$?",
      "options": ["10.000", "40", "1.000", "400"],
      "correctAnswer": 0,
      "conceptId": "power_ten_context",
      "variantIndex": 5,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Machten van 10", "content": "$10^n$ = 1 gevolgd door n nullen. Dus $10^4$ = 10.000 (1 gevolgd door 4 nullen).", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De astronoom weet: $10^n$ = 1 gevolgd door n nullen. Dus $10^4$ = 1 gevolgd door 4 nullen = 10.000. Of: 10 × 10 × 10 × 10 = 10.000.",
        "solutionSteps": ["$10^4$ = 10 × 10 × 10 × 10", "Of: 1 gevolgd door 4 nullen", "= 10.000"],
        "distractorExplanations": {
          "0": "Goed! $10^4$ = 10.000 (1 gevolgd door 4 nullen).",
          "1": "Je dacht waarschijnlijk dat je 10 × 4 = 40 doet. Maar $10^4$ = 10 × 10 × 10 × 10 = 10.000. Onthoud: de exponent is geen factor, maar zegt hoe vaak je vermenigvuldigt.",
          "2": "Je dacht waarschijnlijk dat $10^4$ = $10^3$ = 1.000. Maar de exponent is 4, niet 3. $10^4$ = 10.000 (4 nullen). Onthoud: tel het aantal nullen.",
          "3": "Je dacht waarschijnlijk dat je 4 × 100 = 400 doet. Maar $10^4$ = 10 × 10 × 10 × 10 = 10.000. Onthoud: $10^n$ = 1 gevolgd door n nullen."
        }
      }
    },
    {
      "id": "GET-MACHT-006",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Een wiskundige stelt: $2^4$ en $4^2$ geven hetzelfde antwoord. Klopt dat?",
      "options": ["Ja, beide zijn 16", "Nee, $2^4$ is groter", "Nee, $4^2$ is groter", "Dat kun je niet zeggen"],
      "correctAnswer": 0,
      "conceptId": "power_compare_reasoning",
      "variantIndex": 6,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.80,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Machten vergelijken", "content": "Bereken beide: $2^4$ = 2 × 2 × 2 × 2 = 16. $4^2$ = 4 × 4 = 16. Beide zijn 16, dus ze zijn even groot.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De wiskundige heeft gelijk: bereken beide machten. $2^4$ = 2 × 2 × 2 × 2 = 16. $4^2$ = 4 × 4 = 16. Beide zijn 16, dus ze zijn even groot. Dit is een bijzonder geval — meestal geeft het omdraaien van grondtal en exponent een ander antwoord.",
        "solutionSteps": ["Bereken $2^4$: 2 × 2 × 2 × 2 = 16", "Bereken $4^2$: 4 × 4 = 16", "Vergelijk: 16 = 16 → even groot"],
        "distractorExplanations": {
          "0": "Goed! $2^4$ = 16 en $4^2$ = 16. Ze zijn even groot.",
          "1": "Je dacht waarschijnlijk dat een hogere exponent altijd een groter getal geeft. Maar $2^4$ = 16 en $4^2$ = 16 — ze zijn even groot. Onthoud: bereken altijd beide kanten.",
          "2": "Je dacht waarschijnlijk dat een groter grondtal altijd een groter getal geeft. Maar $4^2$ = 16 en $2^4$ = 16 — ze zijn even groot. Onthoud: bereken altijd beide kanten.",
          "3": "Je dacht waarschijnlijk dat je machten niet kunt vergelijken. Maar je kunt ze altijd uitrekenen en dan vergelijken: $2^4$ = 16 en $4^2$ = 16. Onthoud: bereken eerst, vergelijk dan."
        }
      }
    }
  ]
}
